import { Injectable } from '@angular/core';
import { openWindowWithPostRequest } from '@app/helpers/utils';
import { SecurityService } from '@ng-darwin/security';

/**
 *
 */
@Injectable({
  providedIn: 'root',
})
export class WindowMessagesService {
  public isWebview = false;
  /**
   *
   * @param _securityService
   */
  constructor(private readonly _securityService: SecurityService) {
    const isWebview = sessionStorage.getItem('iswebview');
    this.isWebview = Boolean(isWebview && isWebview === 'true');
  }

  /**
   * @description back
   */
  back(): void {
    this._sendMessage('back');
  }

  /**
   * @description cancel
   */
  cancel(): void {
    this._sendMessage('cancel');
  }

  /**
   * @description error
   */
  error(): void {
    this._sendMessage('error');
  }

  /**
   * @description end
   */
  end(): void {
    this._sendMessage('end');
  }

  /**
   * @description session
   */
  session(): void {
    this._sendMessage('session');
  }

  /**
   * @description _sendMessage
   * @param message string
   */
  private _sendMessage(message: string): void {
    if (this.isWebview && message !== 'session') {
      if (
        this._securityService.token &&
        this._securityService.token !== 'null' &&
        this._securityService.token !== 'undefined'
      ) {
        sessionStorage.setItem('_dwtk', this._securityService.token);
      }
      openWindowWithPostRequest(message, this._shouldSendParamsAsBody());
    } else {
      window.parent.postMessage(
        {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          event_id: message,
        },
        '*',
      );
    }
  }

  private _shouldSendParamsAsBody(): boolean {
    return this.isWebview && !!sessionStorage.getItem('operationChannel');
  }
}
